//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContactForm from '../components/ContactForm'
// import Sponsors from '../components/Sponsors'
import IntSlides from '../components/IntSlides'
// import BreadCrumbs from '../components/BreadCrumbs'
export default {
  auth: false,
  components: {
    // BreadCrumbs,
    // Sponsors,
    ContactForm,
    IntSlides
  },
  data () {
    return {
      lang: 'es',
      cont: {
        es: {
          tit1: 'Somos ' + this.$config.STORE_NAME,
          par1: this.$config.STORE_ABOUT,
          tit2: 'Nuestros Productos',
          par2: 'Traemos los ultimos productos del mercado enfocados en la relación calidad/precio ofreciendoles excelencia, comodidad y que cubran las exigencias de nuestros clientes para que puedan encontrar todo en un solo lugar y pueda ser de mayor agrado.',
          tit3: 'Stock',
          par3: 'Nuestro stock se destaca por una gran variedad de productos de excelente calidad para todas las edades y gustos, en los cuales destacan carteras, bolsos, calzados, medias, ropa niños y dama, pijamas, morrales, paños, trajes de baño, medias panties, pantuflas, camisas, pantalones, loncheras, batas, sudaderas, enterizos, ropa de bebe, calzado de bebe, sostenes, boxers, interiores, suéters, chaquetas, fajas de dama, panties, panty medias, ropa intima caballero y dama, entre otros.',
          tit4: '¡Queremos llegar más allá!',
          par4: `Ya que tenemos alta demanda en nuestros artículos al mayor ponemos a su disposición nuestro servicio de delivery a toda la gran Caracas, contamos con envíos a nivel nacional e internacional, así como también descuentos en compras al gran mayor. Si deseas comunicarte con nosotros puedes hacerlo a través de los siguientes medios: WhatsApp: +${this.$config.STORE_WHATSAPP}, Instagram: ${this.$config.STORE_INSTAGRAM}, Correo: ${this.$config.STORE_EMAIL}. Queremos convertirnos en tu tienda de preferencia y ser su cómplice tanto en sus ocasiones especiales como en su día a día.`
        }
      },
      topSlides: [
        {
          title: '',
          img: 'slider2.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ],
      rightSlides: [
        {
          img: 'about-1.jpg'
        },
        {
          img: 'about-2.jpg'
        }
      ],
      leftSlides: [
        {
          img: 'about-3.jpg'
        },
        {
          img: 'about-4.jpg'
        }
      ]
    }
  },
  head: {
    title: 'Acerca de Nosotros',
    meta: [
      { hid: 'og:title', name: 'og:title', content: 'Acerca de Nosotros' },
      { hid: 'description', name: 'description', content: 'Acerca de Nosotros' }
    ]
  }
}
